// extracted by mini-css-extract-plugin
export default {"imgdiv":"_06655396e3 _6074ef7bc2","img":"b6994a7d6e _508bec8b29"};